import React from 'react';
import MissionsContainer from '../components/MissionsContainer';

const Missions = () => (
  <>
    <MissionsContainer />
  </>
);

export default Missions;
